import { type SupportedLocale, supportedLocale } from '@canvas/intl-types';

export function isLocaleSupported(locale: string): locale is SupportedLocale {
  return supportedLocale.includes(locale as SupportedLocale);
}
